import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Quality', path: '/quality' },
  { name: 'Contact', path: '/contact' }];



  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-gray-950/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group py-4">
            <img
              src="https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/ov2vy98z_Image_202601131834.jpeg"
              alt="Aether Machining"
              className="h-20 w-auto transition-transform duration-300 group-hover:scale-105 !my-[0px] !mx-[10px] md:!mx-[60px] !py-[0px] !px-[0px] !rounded-[25px] !shadow-md"
              style={{ mixBlendMode: 'multiply', filter: 'brightness(1.1) contrast(1.2)' }} />

          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) =>
            <Link
              key={link.name}
              to={link.path}
              className={`text-gray-300 hover:text-red-500 transition-colors duration-200 font-medium ${
              location.pathname === link.path ? 'text-red-500' : ''}`
              }>

                {link.name}
              </Link>
            )}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/contact">
              <Button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md font-semibold transition-all duration-300 shadow-lg hover:shadow-red-600/50">
                Request Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-300 hover:text-white transition-colors duration-200">

            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="lg:hidden py-4 bg-gray-900/95 backdrop-blur-md border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) =>
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-gray-300 hover:text-red-500 transition-colors duration-200 font-medium">

                  {link.name}
                </Link>
            )}
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                <Button className="w-full bg-red-600 hover:bg-red-700 text-white">
                  Request Quote
                </Button>
              </Link>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;